import { CustomFieldDivider } from '../types'
import { http } from './http'

export const fetchCustomFieldDividers = async (): Promise<CustomFieldDivider> => {
  const { data } = await http.get<CustomFieldDivider>('/v2/custom-field-dividers')
  return data
}
